import { createLucideIcon } from "lucide-react";

export const Logout = createLucideIcon(
    "Logout",
    [
        [
            "path",
            {
                d: "M12 2V10",
                key: "1c1vom",
            },
        ],
        [
            "path",
            {
                d: "M7.02331 5.5C4.59826 7.11238 3 9.86954 3 13C3 17.9706 7.02944 22 12 22C16.9706 22 21 17.9706 21 13C21 9.86954 19.4017 7.11238 16.9767 5.5",
                key: "13524c",
            },
        ],
    ],
);
